<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <vue-simple-svg
        :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
        width="40px"
        height="40px"
        class="img"
        :fill="$vuetify.theme.primary"
      />
      <div class="primary--text caption">Line Flex Message</div>
      <v-btn color="primary" depressed @click="showLineFlex = true">{{ $t('Edit') }}</v-btn>
      <v-dialog v-model="showLineFlex" width="1000">
        <v-card>
          <v-layout>
            <v-flex>
              <h3 class="primary--text pa-2">Line Flex Message</h3>
            </v-flex>
            <v-flex>
              <div class="text-xs-right">
                <v-btn flat fab small @click="cancelAddFlexMessage">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-card-text>
            <intent-line-flex-message
              v-model="message"
              :altTextValue.sync="altTextValue"
            ></intent-line-flex-message>
          </v-card-text>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('This messages will not be shown on ') + $t('facebook') + $t('and') + $t('instagram') }}
    </div>
  </div>
</template>

<script>
import IntentLineFlexMessage from './IntentLineFlexMessage'
export default {
  props: ['value', 'altText'],
  data: function() {
    return {
      showLineFlex: false,
      message: null,
      altTextValue: null
    }
  },
  components: {
    IntentLineFlexMessage
  },
  mounted: function() {
    var vm = this
    vm.message = vm.value
    vm.altTextValue = vm.altText
    vm.cached_message = JSON.stringify(vm.value)
    vm.cached_altTextValue = JSON.stringify(vm.altText)
  },
  methods: {
    cancelAddFlexMessage: function() {
      this.showLineFlex = false
      this.message = JSON.parse(this.cached_message)
      this.altTextValue = JSON.parse(this.cached_altTextValue)
    },
    saveAddFlexMessage: function() {
      var vm = this
      if (vm.altTextValue == '') {
        vm.altTextValue = 'You received a message'
      }
      vm.$emit('input', vm.message)
      vm.$emit('update:altText', vm.altTextValue)
      vm.showLineFlex = false
      vm.cached_message = JSON.stringify(vm.message)
      vm.cached_altTextValue = JSON.stringify(vm.altTextValue)
    }
  },
  watch: {
    value: function(newVal) {
      this.message = newVal
    },
    altText: function(newVal) {
      this.altTextValue = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineFlex.vue